import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Tiendas } from "../../Tiendas/Tiendas";
import { VisitasATiendasFilters } from "../VisitasATiendasFilters/VisitasATiendasFilters";
import { ACTCancelarVisita } from "./ACTCancelarVisita";
import { VisitasPorSemanaPersonalViewInfoWindowRenderer } from "./VisitasPorSemanaPersonalViewInfoWindowRenderer";
import { VisitasPorSemanaPersonalViewMarkerRenderer } from "./VisitasPorSemanaPersonalViewMarkerRenderer";
import { VisitasPorSemanaViewInfoWindowRenderer } from "./VisitasPorSemanaViewInfoWindowRenderer";

const columns = () =>
(
    {
        c_ruta_id: new EntityColumn<string>({ name: 'c_ruta_id', type: 'char', length: 20, flags: c.PK, prompt: 'Ruta Id' }),
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PK, prompt: 'Personal Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda Id' }),
        c_horario_id: new EntityColumn<string>({ name: 'c_horario_id', type: 'char', length: 20, flags: c.PK, prompt: 'Horario Id' }),
        c_visita_id: new EntityColumn<string>({ name: 'c_visita_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Visita Id' }),
        d_fecha_visita: new EntityColumn<Date>({ name: 'd_fecha_visita', type: 'date', flags: c.Edit, prompt: 'Fecha Visita' }),
        t_hora_desde: new EntityColumn<string>({ name: 't_hora_desde', type: 'time', flags: c.Edit, prompt: 'Hora Desde' }),
        t_hora_hasta: new EntityColumn<string>({ name: 't_hora_hasta', type: 'time', flags: c.Edit, prompt: 'Hora Hasta' }),
        vc_observaciones_visita: new EntityColumn<string>({ name: 'vc_observaciones_visita', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones Visita' }),
        c_visita_status_id: new EntityColumn<string>({ name: 'c_visita_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Visita Statud Id' }),
        vc_tienda: new EntityColumn<string>({ name: 'vc_tienda', type: 'varchar', length: 255, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Tienda' }),
        vc_personal: new EntityColumn<string>({ name: 'vc_personal', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        viti_brwStandard: { name: 'viti_brwStandard', keyMappings: { c_visita_id: 0 } },
        viti_brwVisitasPorSemana: {
            name: 'viti_brwVisitasPorSemana'
            , keyMappings: { c_visita_id: 0 }
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new VisitasATiendasFilters(client, parentKeys)
            , mapInfoWindowRenderer: VisitasPorSemanaViewInfoWindowRenderer
        },
        viti_brwVisitasPorSemanaPersonal: {
            name: 'viti_brwVisitasPorSemanaPersonal'
            , keyMappings: { c_personal_id: 0 }
            , mapMarkerRenderer: VisitasPorSemanaPersonalViewMarkerRenderer
            , mapInfoWindowRenderer: VisitasPorSemanaPersonalViewInfoWindowRenderer
        }
    }
)

const lookups = () =>
(
    {
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
    }
)

const procs = () =>
(
    {
        viti_CancelarVisita: { name: 'viti_CancelarVisita' }
    }
)

const clientActions = () =>
(
    {
        ACTCancelarVisita: ACTCancelarVisita
    }
)

export class VisitasATiendasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('VisitasATiendas');
    }
}